<mdb-sidenav-layout>
  <mdb-sidenav
    #sidenav="mdbSidenav"
    data-cy="sidenav-threat-pair-alert-log"
    [width]="400"
    [right]="true"
    >
    <div class="position-relative d-flex flex-column h-100">
      <div class="d-flex flex-column p-2 navbar gap-0">
        <div class="d-flex justify-content-between align-items-center w-100">
          <p class="mb-0 fw-bold text-muted">Alert Log</p>
          <button type="button" class="btn-transparent flex-shrink-0" (click)="onClose()" aria-label="Close">
            <i class="fas fa-xmark"></i>
          </button>
        </div>
        @if (pairTitle) {
          <p class="mb-0 small text-muted text-break w-100">{{ pairTitle }}</p>
        }
      </div>

      <div
        class="scrollbar-primary thin overflow-auto d-flex flex-column gap-2 p-2 text-gray-dark flex-grow-1"
        (scroll)="onAlertsScroll($event)"
        >
        <div class="d-flex flex-wrap align-items-end gap-1 mb-1">
          <div class="alerts-filter-field flex-grow-1">
            <label class="form-label small text-muted fw-medium mb-1" for="alertLogFilterFrom">From</label>
            <input
              id="alertLogFilterFrom"
              type="date"
              class="form-control form-control-sm alerts-filter-input"
              [(ngModel)]="filterFrom"
              [disabled]="alertsLoading || loadingMore || downloading"
              />
          </div>
          <div class="alerts-filter-field flex-grow-1">
            <label class="form-label small text-muted fw-medium mb-1" for="alertLogFilterTo">To</label>
            <input
              id="alertLogFilterTo"
              type="date"
              class="form-control form-control-sm alerts-filter-input"
              [(ngModel)]="filterTo"
              [disabled]="alertsLoading || loadingMore || downloading"
              />
          </div>
          <button
            type="button"
            class="btn btn-sm btn-primary flex-shrink-0 alerts-filter-action"
            [disabled]="!filterButtonEnabled"
            (click)="applyAlertsFilter()"
            >
            <i-bs name="filter" class="me-1"></i-bs>
            Filter
          </button>
          <button
            type="button"
            class="btn btn-sm btn-outline-primary flex-shrink-0 alerts-filter-action"
            [disabled]="!downloadButtonEnabled"
            (click)="downloadAlertsJson()"
            >
            @if (downloading) {
              <span class="spinner-border spinner-border-sm" role="status"></span>
            } @else {
              <i class="fas fa-download"></i>
            }
          </button>
        </div>

        @if (alertsLoading && !allAlerts.length) {
          <div
            class="text-center py-4 text-muted small"
            >
            <span class="spinner-border spinner-border-sm me-2" role="status"></span>
            Loading alerts…
          </div>
        }

        @if (!(alertsLoading && !allAlerts.length)) {
          <div
            class="d-flex flex-column gap-3 pt-1"
            >
            @for (alert of displayedAlerts; track alert) {
              <div class="card shadow-sm border rounded-3">
                <div class="card-body py-2 px-2">
                  <div class="d-flex flex-wrap align-items-start justify-content-between gap-2 mb-2">
                    <span class="small text-muted">{{ alert.timestampLabel }}</span>
                    <div class="d-flex flex-wrap gap-1 justify-content-end">
                      @for (ch of alert.channels; track ch) {
                        <span
                          class="badge rounded-pill fw-semibold"
                          [ngClass]="channelBadgeClasses(ch.variant)"
                          >
                          {{ ch.label }}
                        </span>
                      }
                    </div>
                  </div>
                  <p class="alert-breach-message mb-2 fw-semibold d-flex align-items-center lh-sm" [ngClass]="{'text-danger': isThresholdBreached(alert)}">
                    @if (isThresholdBreached(alert)) {
                      <i-bs name="exclamation-triangle-fill" class="alert-breach-icon text-danger flex-shrink-0 me-1 mb-1"></i-bs>
                    }
                    <span>{{ breachMessage(alert) }}</span>
                  </p>
                  <div class="d-flex flex-wrap gap-2 small">
                    <span class="notification-recipient-badge d-inline-flex align-items-center gap-1 badge rounded-pill bg-primary-dark bg-opacity-10 text-primary-dark fw-semibold">
                      <span>Victim · {{ notificationStatusLabel(alert.survivorStatus) }}</span>
                      <i
                        class="fas"
                        [ngClass]="[notificationStatusIcon(alert.survivorStatus), notificationStatusClass(alert.survivorStatus)]"
                        [attr.aria-label]="notificationStatusLabel(alert.survivorStatus)"
                        [mdbTooltip]="getNotificationStatusTooltip(alert.survivorStatus)"
                        [html]="true"
                        ></i>
                    </span>
                    @if (isThresholdBreached(alert)) {
                    <span class="notification-recipient-badge d-inline-flex align-items-center gap-1 badge rounded-pill bg-primary-darker bg-opacity-10 text-primary-darker fw-semibold">
                      <span>Accused · {{ notificationStatusLabel(alert.perpetratorStatus) }}</span>
                      <i
                        class="fas"
                        [ngClass]="[notificationStatusIcon(alert.perpetratorStatus), notificationStatusClass(alert.perpetratorStatus)]"
                        [attr.aria-label]="notificationStatusLabel(alert.perpetratorStatus)"
                        [mdbTooltip]="getNotificationStatusTooltip(alert.perpetratorStatus)"
                        [html]="true"
                        ></i>
                    </span>
                    }
                  </div>
                </div>
              </div>
            }
            @if (!displayedAlerts.length) {
              <div class="card border bg-light rounded-3 shadow-none">
                <div class="card-body text-center py-4 text-muted">
                  <i-bs name="bell" width="2rem" height="2rem" class="d-block mx-auto mb-2"></i-bs>
                  No alerts in this range.
                </div>
              </div>
            }
            @if (loadingMore) {
              <div class="text-center py-2 text-muted small">
                <span class="spinner-border spinner-border-sm me-2" role="status"></span>
                Loading more…
              </div>
            }
          </div>
        }
      </div>
    </div>
  </mdb-sidenav>
  <mdb-sidenav-content #sidenavContent></mdb-sidenav-content>
</mdb-sidenav-layout>
